<template>
    <div>
        <button class="d-none" @click="openModal()" id="openOrderModal">open</button>

        
        <div class="modal fade" id="openOrdersModal" tabindex="-1" aria-labelledby="openOrdersModal" aria-hidden="true">
               <div class="modal-dialog modal-xl">

                   <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Nouvelle facturation groupée</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fal fa-times"></i>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label class="required">Société</label>
                                    <div class="input-group mb-3">
                                        <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="companySearchInput" type="text" v-model="company">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary"  @click="removeCompany()" type="button" id="button-addon2"><i class="fas fa-trash"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="!loading && orders && orders.length > 0">
                                <div class="col-sm-12">
                                    <h5>Liste des commandes clients</h5>
                                    <div class="ix-table-box">
                                        <table class="ix-table ix-table-sm"> 
                                            <thead>
                                                <tr>
                                                    <th class="min">
                                                        <input type="checkbox" v-model="selectAll" @change="addAllSelectedOrder" />
                                                    </th>
                                                    <th>Statut</th>
                                                    <th>Numéro</th>
                                                    <th>Désignation</th>
                                                    <th>Affaire</th>
                                                    <th class="text-right">Total HT</th>
                                                    <th class="text-right">Total TTC</th>
                                                    <th class="text-right">Reste à facturer HT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(order, index) in orders">
                                                <tr>
                                                    <td>
                                                        <input type="checkbox" v-model="order.isSelected" @change="addSelectedOrder(order)" />
                                                    </td>

                                                    <td>
                                                        <span class="ix-state green" v-if="order.status">Facturable</span>
                                                        <span class="ix-state yellow" v-if="!order.status">Non facturable</span>
                                                    </td>
                                                    <td>
                                                        {{ order.number }}
                                                    </td>
                                                    <td>
                                                        {{ order.designation }}
                                                    </td> 
                                                    <td>
                                                        <span v-if="order.deal" v-html="truncate(order.deal.number + ' - ' + order.deal.name, 30)"></span>
                                                    </td>
                                                    <td  class="text-right"> 
                                                        {{ currency(order.total_ht)}}
                                                    </td>
                                                     <td  class="text-right"> 
                                                        {{ currency(order.total_ttc)}}
                                                    </td>
                                                     <td  class="text-right"> 
                                                        {{ currency(order.total_remaining)}}
                                                    </td>
                                                </tr>
                                                <tr v-if="allowGuarantee && order.guarantee_check_amount > 0">
                                                    <td colspan="6"> 
                                                       <i> <i class="fas fa-angle-right"></i> Dépôt de garantie : {{currency(parseFloat(order.guarantee_check_amount).toFixed(2))}} le {{moment(order.guarantee_date_at).format('DD/MM/YYYY')}}</i>
                                                    </td>
                                                </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="row" v-if="!loading && orders && orders.length == 0 && company">
                                <div class="col-sm-12">
                                    <div class="alert alert-warning">Aucune commande disponible</div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="ix-btn green" v-bind:disabled="!checkForm() || loading" @click="post()">
                                <span v-if="!loading">Enregistrer</span>
                                <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i></span>
                            </button>
                        </div>

                   </div>

               </div>
        </div>
    </div>
    
</template>


<script>



export default {
    name: 'GroupOrders',
    props: ['companyUrl', 'ordersUrl', 'dealsUrl', 'allowGuarantee'],
    data(){
        return {
            company: null,
            company_id: null,
            orders : [],
            loading: false,
            selectedOrders: [],
            selectAll: false,
        }
    },
    methods : {
        openModal(){
            $('#openOrdersModal').modal()
        },
        removeCompany(){
            this.company = null;
            this.company_id = null;
            this.orders = [];
            this.selectedOrders = [];
            this.selectAll = false;
            $('#companySearchInput').val('');
        },
        removeDeal(){
            this.deal.id = null;
            this.deal.designation = null;
        },
        addOrders(company){
            this.orders = [];
            this.selectedOrders = [];
            if(company.orders && company.orders.length > 0){
                this.orders = company.orders;
            }
        },
        addSelectedOrder(order){
             // Check if the order is selected, then add it to selectedOrders
            if (order.isSelected ) {
                const existingIndex = this.selectedOrders.findIndex(selectedOrder => selectedOrder.id === order.id);
                if (existingIndex === -1) {
                    // If the order does not exist, add it to selectedOrders
                    this.selectedOrders.push(order);
                  
                }
            } else {
                // If not selected, remove it from selectedOrders
                const index = this.selectedOrders.findIndex(selectedOrder => selectedOrder.id === order.id);;
                if (index !== -1) {
                    this.selectedOrders.splice(index, 1);
                }
                
            }
        },
        addAllSelectedOrder(){
              if (this.orders && this.orders.length > 0) {
                this.orders.forEach(order => {
                    if (order) {
                        order.isSelected = this.selectAll;
                        this.addSelectedOrder(order);
                    }
                });
            }
        },
        checkForm(){
            return this.company != null && this.selectedOrders && this.selectedOrders.length >= 2;
        },
        async post(){
            this.loading = true
            var sumGuarantee = 0;
            this.selectedOrders.forEach(g => {
                // Conversion et formatage avec 2 décimales
                sumGuarantee += parseFloat(parseFloat(g.guarantee_check_amount || 0).toFixed(2));
            });
            var data = {
                company_id: this.company_id,
                orderIds : this.selectedOrders.map(orders => {return orders.id }),
                order_guarantee_check_amount : parseFloat(sumGuarantee.toFixed(2))
            }


            fetch(this.ordersUrl, {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: 'POST',
                    body: JSON.stringify(data)
                }
            }).then((response) => {
              return response.json();
            }).then((data) => {
                window.location.href = data.redirect;
            }).catch((error) => {
                console.log(error);
            });
        }
    },
    mounted() { 
        $("#companySearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.companyUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, with_relations: 1 },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                       
                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.designation}</span>
                                    </div>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                search: (e, item) => {
                    if ($(e.target).val() == '' || $(e.target).val() == null) {
                        this.removeCompany();
                    }
                },
                change: (e, item) => {
                    if(!item.item){   
                        this.removeCompany();    
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                      this.company = item.item.designation
                      this.company_id = item.item.id;
                      this.loading = true;
                      this.addOrders(item.item);
                      this.loading = false;
                
                    }
                },
            }).focus(() => {
                $("#companySearchInput").autocomplete("search", '');
        });

    },
}
</script>